// @core/api/endpoints/document/list_document_registrations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentRegistrationsResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List registrations
 * Returns registration entries from a document register.
 */
export async function ListDocumentRegistrations(
  register_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDocumentRegistrationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-registers/:register_id/registrations`;
  requestPath = requestPath.replace(':register_id', encodeURIComponent(register_id));
  const requestOptions = options;
  return client.get<ListDocumentRegistrationsResponse>(requestPath, { ...requestOptions, params });
}
